import request from "./httpService";

const REPORTING_ENDPOINT = '/reporting';

export const reportingService = {
  getDailySalesReport(date, locationId = null, page = 1, limit = 50) {
    const params = { date, page, limit };
    if (locationId) params.locationId = locationId;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/daily-sales`,
      params: params
    });
  },

  getMonthlySalesReport(year, month, locationId = null, page = 1, limit = 50) {
    const params = { year, month, page, limit };
    if (locationId) params.locationId = locationId;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/monthly-sales`,
      params: params
    });
  },

  getInventoryReport(type = null) {
    const params = {};
    if (type) params.type = type;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/inventory`,
      params: params
    });
  },

  getCustomerReport(period, date) {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/customers`,
      params: { period, date }
    });
  },

  getPaymentMethodsReport(startDate, endDate) {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/payment-methods`,
      params: { startDate, endDate }
    });
  },

  getIndividualCustomerReport(customerId, startDate = null, endDate = null) {
    const params = { customerId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/individual-customer`,
      params: params
    });
  },

  getReportTypes() {
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/types`
    });
  },

  // Export methods
  exportDailySalesReportToExcel(date, locationId, page = 1, limit = 200) {
    const params = { date, locationId, page, limit };
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/daily-sales/export/excel`,
      params: params,
      responseType: 'blob' // Important for file downloads
    });
  },

  exportDailySalesReportToPDF(date, locationId, page = 1, limit = 200) {
    const params = { date, locationId, page, limit };
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/daily-sales/export/pdf`,
      params: params,
      responseType: 'blob', // Important for file downloads
      headers: {
        'Accept': 'application/pdf'
      }
    });
  },

  // Monthly Sales Export methods
  exportMonthlySalesReportToExcel(year, month, locationId = null, page = 1, limit = 200) {
    const params = { year, month, page, limit };
    if (locationId) params.locationId = locationId;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/monthly-sales/export/excel`,
      params: params,
      responseType: 'blob' // Important for file downloads
    });
  },

  exportMonthlySalesReportToPDF(year, month, locationId = null, page = 1, limit = 200) {
    const params = { year, month, page, limit };
    if (locationId) params.locationId = locationId;
    
    return request({
      method: "GET",
      url: `${REPORTING_ENDPOINT}/monthly-sales/export/pdf`,
      params: params,
      responseType: 'blob', // Important for file downloads
      headers: {
        'Accept': 'application/pdf'
      }
    });
  },

  // Generic export method for future reports
  exportReport(reportType, format, params) {
    const config = {
      method: "GET",
      url: `${REPORTING_ENDPOINT}/${reportType}/export/${format}`,
      params: params,
      responseType: 'blob'
    };

    // Set appropriate Accept header based on format
    if (format === 'pdf') {
      config.headers = { 'Accept': 'application/pdf' };
    } else if (format === 'excel') {
      config.headers = { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
    }

    return request(config);
  }
};

export default reportingService;
